import React from 'react'
import InfoButton from "./InfoButton";
import LangButton from "./LangButton";

export default function Tools(props) {
    return (
    <div className="tools is-flex gap-4">
        <InfoButton/>
        <LangButton/>
    </div>
    )
}
